import React from 'react'

const NotFount = () => {
  return (
    <div className='text-danger text-center h3'>404 Page Not Found</div>
  )
}

export default NotFount